/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFPrivacyCookieCompliance
 */
export interface CRSFPrivacyCookieCompliance {
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyCookieCompliance
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyCookieCompliance
     */
    tier: string;
}

/**
 * Check if a given object implements the CRSFPrivacyCookieCompliance interface.
 */
export function instanceOfCRSFPrivacyCookieCompliance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "tier" in value;

    return isInstance;
}

export function CRSFPrivacyCookieComplianceFromJSON(json: any): CRSFPrivacyCookieCompliance {
    return CRSFPrivacyCookieComplianceFromJSONTyped(json, false);
}

export function CRSFPrivacyCookieComplianceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyCookieCompliance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider': json['provider'],
        'tier': json['tier'],
    };
}

export function CRSFPrivacyCookieComplianceToJSON(value?: CRSFPrivacyCookieCompliance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider': value.provider,
        'tier': value.tier,
    };
}

